import { render, staticRenderFns } from "./ValueProporsition.vue?vue&type=template&id=e56c040e&scoped=true&"
import script from "./ValueProporsition.vue?vue&type=script&lang=js&"
export * from "./ValueProporsition.vue?vue&type=script&lang=js&"
import style0 from "./ValueProporsition.vue?vue&type=style&index=0&id=e56c040e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56c040e",
  null
  
)

export default component.exports